import { Action } from 'redux';
import { WorkspacePermissions } from '../../types/Permission';

export interface ACState {
  permissions?: WorkspacePermissions;
  roles?: string[];
}

type ACAction = Action & {
  user: { roles: string[] };
  permissions: WorkspacePermissions;
};

const accessControlReducer = (
  state: ACState = { permissions: {} },
  action: ACAction
): ACState => {
  const { type, permissions, user } = action;
  switch (type) {
    case 'UPDATE_APP_STATE':
      if (user?.roles) {
        return { ...state, roles: user.roles };
      }
      return state;
    case 'SET_PERMISSIONS':
      return {
        ...state,
        permissions: {
          ...state.permissions,
          ...permissions
        }
      };
    default:
      return state;
  }
};

export default accessControlReducer;
